var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a14.46 14.46 0 0 0-8.14 2.38.49.49 0 0 0-.19.56l1 3a.74.74 0 0 0 1.16.34 9.94 9.94 0 0 1 6.2-2c1.014 0 2.023.138 3 .41a.6.6 0 0 0 .23.06 8.77 8.77 0 0 1 3 1.53.72.72 0 0 0 .46.16h.21a.71.71 0 0 0 .48-.47l1-3a.49.49 0 0 0-.19-.56A14.46 14.46 0 0 0 12 5zm6.52 5.24A9.44 9.44 0 0 0 16.08 9l.89-1a.51.51 0 0 0 0-.71.51.51 0 0 0-.71.06L15 8.64a12.1 12.1 0 0 0-3-.39 11.1 11.1 0 0 0-6.52 2L4.74 8A13.6 13.6 0 0 1 12 6a13.6 13.6 0 0 1 7.26 2l-.74 2.24z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1h-17A2.5 2.5 0 0 0 1 3.5v17A2.5 2.5 0 0 0 3.5 23h17a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 20.5 1zM22 20.5a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 20.5v-17A1.5 1.5 0 0 1 3.5 2h17A1.5 1.5 0 0 1 22 3.5v17z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.6c0161bada0c144f416557bdd1f8f84f.svg";
export { ForwardRef as ReactComponent };